import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  React.useEffect(() => {
    if (user) {
      navigate('/admin');
    }
  }, [user, navigate]);

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    
    try {
      await login();
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="admin-container">
      <div id="admin-side">
        <div className="text-center mb-4">
          <img 
            src="/assets/denmoda.png" 
            alt="DenModa Logo" 
            style={{ maxWidth: '150px' }}
          />
          <h2 className="mt-3">Admin Login</h2>
          <p className="text-muted">Sign in to manage your website content</p>
        </div>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        <button
          type="button"
          className="btn btn-light w-100 d-flex align-items-center justify-content-center gap-2 py-3"
          onClick={handleGoogleLogin}
          disabled={loading}
          style={{ 
            borderRadius: '50px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm" role="status"></span>
              Signing in...
            </>
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google
            </>
          )}
        </button>

        <div className="text-center mt-4">
          <a href="/" className="text-decoration-none" style={{ color: '#58eecd' }}>
            <i className="bi bi-arrow-left"></i> Back to Website
          </a>
        </div>

        <div className="text-center mt-4">
          <small className="text-muted">
            Only authorized administrators can access this panel.
          </small>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
